import React from 'react';
import { connect } from 'react-redux';
import { Grid } from 'semantic-ui-react';
import EntitiesErrorMessages from '@/components/errors/EntitiesErrorMessages';
import fetch, { fetchConfig } from '@/hooks/fetch';
import UserPanelContainer, { mapDispatchToProps, mapStateToProps } from '../components/UserPanelContainer';
import UserSummary from './UserSummary';
import UserStatus from './UserStatus';
import UserPanelTabs from '../components/UserPanelTabs';

const UserPanelFull = ({
  canRead,
  category,
  code,
  exists,
  fetchData,
  isDirty,
  name,
  onChange,
  readErrors,
  readStatus,
  updateErrors,
  url,
  updateProperties,
  user,
}) => {
  fetch.useFetchByCode(fetchData, category, code, readStatus, fetchConfig([], () => !user));
  return (
    <UserPanelContainer
      canRead={canRead}
      category={category}
      code={code}
      exists={exists}
      isDirty={isDirty}
      name={name}
      onChange={onChange}
      readErrors={readErrors}
      readStatus={readStatus}
      url={url}
    >
      <div className="aridhia-user-panel-full">
        <EntitiesErrorMessages
          category={category}
          code={code}
          entities={['user', 'server']}
          entity="user"
          errors={updateErrors}
          onDismiss={(errors) => updateProperties(category, code, { updateErrors: errors })}
        />
        <Grid>
          <Grid.Row columns="equal">
            <Grid.Column>
              <UserSummary code={code} category={category} />
            </Grid.Column>
            <Grid.Column textAlign="right">
              <UserStatus code={code} category={category} />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row columns="1">
            <Grid.Column>
              <UserPanelTabs code={code} category={category} />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    </UserPanelContainer>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(UserPanelFull);
